import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment/moment";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addLiveStream,
  editLiveStream,
  getCategoryDropDown,
  getTopicDropDown,
  imageUpload,
} from "../../../features/slices/liveStream";
import { toastService } from "../../../utils/toastify";
const initialState = {
  title: "",
  categoryId: "",
  topicId: "",
  date: "",
  time: "",
  description: "",
  link: "",
  teacherName: "",
  aboutTeacher: "",
  profilePic: "",
  thumbnail: "",
  id: "",
};
const EditLivestream = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [errors, setErrors] = useState({});
  useEffect(() => {}, []);
  const navigate = useNavigate();
  const {
    title,
    categoryId,
    topicId,
    date,
    time,
    description,
    link,
    teacherName,
    aboutTeacher,
    thumbnail,
    profilePic,
    id,
  } = iState;
  const dispatch = useDispatch();
  const { categoryDropDownData, loading, topicDropDowndata } = useSelector(
    (state) => state.liveStream
  );
  const { state } = useLocation();

  useEffect(() => {
    dispatch(getCategoryDropDown());
    dispatch(getTopicDropDown({ categoryId: state?.categoryId }));
    setUpdateState({
      ...iState,
      title: state?.title || "",
      categoryId: state?.categoryId || "",
      topicId: state?.topicId || "",
      date: state?.date || "",
      time: state?.time || "",
      description: state?.description || "",
      link: state?.link || "",
      teacherName: state?.teacherName || "",
      aboutTeacher: state?.aboutTeacher || "",
      thumbnail: state?.thumbnail || "",
      profilePic: state?.profilePic || "",
      id: state?._id || "",
    });
  }, []);
  const handleChangeCategory = (e) => {
    setUpdateState({ ...iState, [e.target.name]: e.target.value });
    dispatch(getTopicDropDown({ categoryId: e.target.value })).then(
      (data) => {}
    );
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "date") {
      const formattedDate = moment(value).format("DD-MM-YYYY");
      setUpdateState({ ...iState, [name]: formattedDate });
    } else {
      setUpdateState({ ...iState, [name]: value });
    }
  };

  const handleImage = (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append("fileName", file);
      dispatch(imageUpload(formData)).then((result) => {
        if (result?.payload?.code === 200) {
          setUpdateState({
            ...iState,
            [event.target.name]: result?.payload?.url,
          });
        }
      });
    }
  };

  const validateForm = () => {
    let formErrors = {};
    let isValid = true;

    if (!title?.trim()) {
      formErrors.title = "title is required.";
      isValid = false;
    }

    if (!categoryId?.trim()) {
      formErrors.categoryId = "category is required.";
      isValid = false;
    }
    if (!topicId?.trim()) {
      formErrors.topicId = "topic is required.";
      isValid = false;
    }

    if (!date?.trim()) {
      formErrors.date = "date is required.";
      isValid = false;
    }
    if (!time?.trim()) {
      formErrors.time = "time is required.";
      isValid = false;
    }
    if (!description?.trim()) {
      formErrors.description = "description is required.";
      isValid = false;
    }
    if (!link?.trim()) {
      formErrors.link = "link is required.";
      isValid = false;
    }
    if (!teacherName?.trim()) {
      formErrors.teacherName = "teacherName is required.";
      isValid = false;
    }
    if (!aboutTeacher?.trim()) {
      formErrors.aboutTeacher = "aboutTeacher is required.";
      isValid = false;
    }
    if (!profilePic?.trim()) {
      formErrors.profilePic = "profilePic is required.";
      isValid = false;
    }
    if (!thumbnail?.trim()) {
      formErrors.thumbnail = "thumbnail is required.";
      isValid = false;
    }
    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      dispatch(editLiveStream(iState)).then((res) => {
        if (res?.payload?.code === 200) {
          toastService.success("Livestream edited successfully");
          setUpdateState(initialState);
          navigate("/livestream");
        } else {
          toastService.error("Livestream edit failed");
        }
      });
    }
  };
  return (
    <div className="WrapperArea">
      <div className="WrapperBox">
        <div className="Small-Wrapper">
          <div className="TitleBox Border">
            <h4 className="Title">Edit Live Stream</h4>
          </div>
          <div className="CommonForm">
            <div className="form-group">
              <label>Livestream Title</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Livestream Name"
                name="title"
                value={title}
                onChange={handleChange}
              />
              {errors.title && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.title}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Category</label>
              <select
                className="form-control"
                name="categoryId"
                onChange={handleChangeCategory}
              >
                <option>select</option>
                {categoryDropDownData?.result?.map((res) => {
                  return (
                    <option value={res?._id} selected={res?._id == categoryId}>
                      {res?.categoryName}
                    </option>
                  );
                })}
              </select>
              {errors.categoryId && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.categoryId}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Topic</label>
              <select
                className="form-control"
                name="topicId"
                onChange={handleChange}
              >
                <option>select</option>
                {topicDropDowndata &&
                  topicDropDowndata?.result?.map((res) => {
                    return (
                      <option value={res?._id} selected={res?._id == topicId}>
                        {res?.topicName}
                      </option>
                    );
                  })}
              </select>
              {errors.topicId && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.topicId}
                </p>
              )}
            </div>
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Date</label>
                  <input
                    type="date"
                    className="form-control"
                    name="date"
                    value={moment(date, "DD-MM-YYYY").format("YYYY-MM-DD")}
                    onChange={handleChange}
                  />
                  {errors.date && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.date}
                    </p>
                  )}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label>Time</label>
                  <input
                    type="time"
                    className="form-control"
                    name="time"
                    value={time}
                    onChange={handleChange}
                  />
                  {errors.time && (
                    <p className="d-flex justify-content-start text-danger mt-2 ">
                      {errors.time}
                    </p>
                  )}
                </div>
              </div>
            </div>
            <div className="form-group">
              <label>Description</label>
              <textarea
                className="form-control"
                placeholder="Write here..."
                rows={4}
                name="description"
                value={description}
                onChange={handleChange}
              />
              {errors.description && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.description}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Link</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Link"
                name="link"
                value={link}
                onChange={handleChange}
              />
              {errors.link && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.link}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>Teacher Name</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter Teacher Name"
                name="teacherName"
                value={teacherName}
                onChange={handleChange}
              />
              {errors.teacherName && (
                <p className="d-flex justify-content-start text-danger mt-2 ">
                  {errors.teacherName}
                </p>
              )}
            </div>
            <div className="form-group">
              <label>About Teacher</label>
              <textarea
                className="form-control"
                placeholder="Write here..."
                rows={4}
                name="aboutTeacher"
                value={aboutTeacher}
                onChange={handleChange}
              />
            </div>
            {errors.aboutTeacher && (
              <p className="d-flex justify-content-start text-danger mt-2 ">
                {errors.aboutTeacher}
              </p>
            )}
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Profile</h4>
          </div>
          <div className="CommonForm">
            <div
              className="UploadBox Image"
              style={{
                position: "relative",
              }}
            >
              <span
                style={{
                  zIndex: "99",
                }}
              >
                {/* Display the preview image */}
                {profilePic ? (
                  <>
                    <img
                      src={profilePic}
                      alt="Profile Preview"
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        mixBlendMode: "darken",
                      }}
                    />
                    <i
                      className="fas fa-edit"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        color: "#fff",
                        background: "rgba(0, 0, 0, 0.6)",
                        borderRadius: "50%",
                        padding: "5px",
                        zIndex: 2, // Place icon above the image
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document.querySelector(`#file-image-input`).click()
                      } // Trigger file input on icon click
                    />
                  </>
                ) : (
                  <p>No image uploaded</p>
                )}
              </span>
              <input
                id="file-image-input"
                type="file"
                accept=".png,.jpg,.jpeg"
                name="profilePic"
                onChange={handleImage}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              {!profilePic && (
                <p>
                  <label>Click to upload</label> or <br /> drag &amp; drop
                </p>
              )}
            </div>
          </div>
          <div className="TitleBox Border">
            <h4 className="Title">Upload Live Stream Thumbnail</h4>
          </div>
          <div className="CommonForm">
            <div
              className="UploadBox Image"
              style={{
                position: "relative",
              }}
            >
              <span
                style={{
                  zIndex: "99",
                }}
              >
                {thumbnail && (
                  <>
                    <img
                      src={thumbnail}
                      style={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        mixBlendMode: "darken",
                      }}
                    />
                    <i
                      className="fas fa-edit"
                      style={{
                        position: "absolute",
                        top: "5px",
                        right: "5px",
                        color: "#fff",
                        background: "rgba(0, 0, 0, 0.6)",
                        borderRadius: "50%",
                        padding: "5px",
                        zIndex: 2, // Place icon above the image
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        document.querySelector(`#file-image-input`).click()
                      } // Trigger file input on icon click
                    />
                  </>
                )}
              </span>
              <input
                id="file-image-input"
                type="file"
                accept=".png,.jpg,.jpeg"
                name="thumbnail"
                onChange={handleImage}
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%",
                  opacity: 0,
                  cursor: "pointer",
                }}
              />
              {!thumbnail && (
                <p>
                  <label>Click to upload</label> or <br /> drag &amp; drop
                </p>
              )}
            </div>
          </div>
          <button className="Button" onClick={handleSubmit}>
            Update
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditLivestream;
